export const hasBothDates = (startDate: string, endDate: string): boolean =>
  !!startDate && !!endDate;
